import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {EntityLogo} from "../../../core/components/logos/entity-logo";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import {EntityCarousel} from "../../../core/components/entity-carousel/entity-carousel";
import {CompetitorPlayersStatsModuleHeaderTitles} from "./competitor-players-stats-module.header.titles";
import {Link} from "../../../core/components/link/link";
import styles from "../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";
import {GameCard, GameCardComponentProps} from "../../../core/components/game-card/components/game-card";
import {RELATED_GAMES} from "../../../widgets/match-widget/modules/related-games-module/related-games-widget-consts";
import {APP} from "../../../core/app/consts";

export class CompetitorPlayersStatsModuleHeaderProps extends BaseProps {
  controller: CompetitorPlayersStatsModuleController;
  onPlayerChange: Function;
}

export const CompetitorPlayersStatsModuleHeader = ({
                                                     controller,
                                                     onPlayerChange,
                                                     source
                                                   }: CompetitorPlayersStatsModuleHeaderProps) => {
  const {state, device} = controller;
  const {isSmallView, isRtl} = device;
  const {
    isSinglePlayer,
    selectedCompetitor,
    shouldRenderGameCard,
    gameViewModel,
    isInnerLinksBlocked,
    currentLinkModel,
    gameStatus,
    terms,
    gameId,
    players,
    playerIndex,
    activeItemWidth
  } = state;

  const linkProps = {
    className: classNames(styles.header_logo_container),
    model: selectedCompetitor.linkModel,
  }

  const logoProps = {
    entity: selectedCompetitor,
    width: isSmallView ? COMPETITOR_PLAYER_STATS.DESIGN.COMPETITOR_LOGO_SIZE.mobile : COMPETITOR_PLAYER_STATS.DESIGN.COMPETITOR_LOGO_SIZE.desktop,
    height: isSmallView ? COMPETITOR_PLAYER_STATS.DESIGN.COMPETITOR_LOGO_SIZE.mobile : COMPETITOR_PLAYER_STATS.DESIGN.COMPETITOR_LOGO_SIZE.desktop,
  }

  const carouselProps = {
    entities: players,
    itemIndex: playerIndex,
    onItemChange: onPlayerChange,
    activeItemWidth,
    isSingleItem: isSinglePlayer,
    isSmallView,
    isRtl
  }

  const onMatchClickEvent = () => {
    controller.action(RELATED_GAMES.ACTION_TYPES.relatedGamesMatchDetailsClick, {
      gameId,
      competitionId: gameViewModel?.competitionId,
      status: gameStatus,
      source: source,
      placement: APP.GOOGLE_ANALYTICS.SOURCES.playerStatsDiv,
      currentLinkModelName: currentLinkModel.name,
      sportTypeId: gameViewModel?.sportId,
      relatedGameId: gameId,
    });

    return true;
  }

  const gameProps: GameCardComponentProps = {
    game: gameViewModel,
    controller,
    device,
    isSmallView,
    i18n: terms,
    onClick: !isInnerLinksBlocked ? onMatchClickEvent : null,
    disableSelection: true,
    hideIcons: true,
  }

  return (
    <div className={classNames(styles.header_container)}>
      <div className={classNames(styles.header_content)}>
        {
          <Link {...linkProps}>
            <EntityLogo {...logoProps}/>
          </Link>
        }
        {
          isSinglePlayer ?
            null :
            <EntityCarousel {...carouselProps}/>
        }

        <CompetitorPlayersStatsModuleHeaderTitles controller={controller}/>
      </div>
      {
        shouldRenderGameCard ? <GameCard {...gameProps} /> : null
      }
    </div>

  )
}
